<template>
  <div class="position-relative dinA4">
    <img :src="require('@/assets/additional-inter-header.png')" class="page__header" />
    <div class="page__container">
      <table class="full-width mt-0">
        <tr class="primary-background">
          <th colspan="2" class="primary-background h1 color-white text-left pl-4 mb-0">
            Serv. Adic. CTT INTERNACIONAL EXPRESS & ECONOMY
          </th>
        </tr>
        <tr>
          <td class="body-2">
            {{ $t('SEG_TX_VOL') }}
          </td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('SEG_TX_VOLUNTARIO').value }}% (min
            {{ getAdditionalServiceById('SEG_TX_VOLUNTARIO').minValue
            }}<span class="euro-symbol">€</span>)
          </td>
        </tr>
        <tr>
          <td class="body-2">
            {{ $t('POD') }}
          </td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('POD').value }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">
            {{ $t('RWA') }}
          </td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('RWA').value }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">
            {{ $t('REMOTE_AREAS') }}
          </td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('AREAS_REMOTAS').value }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">
            {{ $t('REMOTE_AREAS_KG') }}
          </td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('AREAS_REMOTAS_KG').value
            }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">
            {{ $t('DRY_ICE') }}
          </td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('HIELO_SECO').value }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">
            {{ $t('PRIORITY') }}
          </td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('ENV_PRIORITARIO').value
            }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">{{ $t('SHIPMENT_9_MIN_70') }} (*)</td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceByDesc('SHIPMENT_9_MIN_70').value
            }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">{{ $t('SHIPMENT_9_MAX_70') }} (*)</td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceByDesc('SHIPMENT_9_MAX_70').value
            }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">{{ $t('SHIPMENT_10_MIN_70') }} (*)</td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceByDesc('SHIPMENT_10_MIN_70').value
            }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">{{ $t('SHIPMENT_10_MAX_70') }} (*)</td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceByDesc('SHIPMENT_10_MAX_70').value
            }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">
            {{ $t('SHIPMENT_12_MIN_70') }}
          </td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceByDesc('SHIPMENT_12_MIN_70').value
            }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">
            {{ $t('SHIPMENT_12_MAX_70') }}
          </td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceByDesc('SHIPMENT_12_MAX_70').value
            }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">
            {{ $t('EXPORT_OUT_UE') }}
          </td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('EXPORT_FUERA_UE').value
            }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">
            {{ $t('BAT_LITIO') }}
          </td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('BAT_LITIO').value }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">
            Almacenaje Internacional en Destino
          </td>
          <td class="body-2 text-center">
            Coste variable (consular)
          </td>
        </tr>
        <tr>
          <td class="body-2">
            Entrega en Islas
          </td>
          <td class="body-2 text-center">
            Coste variable (consular)
          </td>
        </tr>
        <tr>
          <td class="body-2">
            {{ $t('DEV_SHIPMENTS') }}
          </td>
          <td class="body-2 text-center">
            Misma tarifa que de salida
          </td>
        </tr>
      </table>

      <p class="body-2 body-2--bold mb-2 mt-4">
        Otras consideraciones de los Servicios de Internacional:
      </p>
      <ul class="list-style-none body-2">
        <li class="pl-4">
          - Internacional Express: Seguro de transporte: Convenio de Varsovia (20€ kg real
          siniestrado).
        </li>
        <li class="pl-4">
          - Internacional Economy: Seguro de transporte: CMR (indemnización máxima de 10€ por kg
          peso bruto).
        </li>
        <li class="pl-4">
          - La unidad monetaria de esta tarifa es el Euro (<span class="euro-symbol">€</span>). Esta
          tarifa no incluye impuestos tales como el IVA y gastos derivados de la exportación /
          importación.
        </li>
        <li class="pl-4">
          (*) Solo disponible en el Servicio Internacional Express.
        </li>
      </ul>
    </div>

    <Footer logo :page="previousPages + 1" />
  </div>
</template>

<script>
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2022/Footer'

export default {
  name: 'AdditionalServicesInternational',
  components: { Footer },
  data() {
    return {
      previousPages: 0,
    }
  },
  methods: {
    getAdditionalServiceById(id) {
      return this.$parent.getAdditionalServiceById(id)
    },
    getAdditionalServiceByDesc(desc) {
      return this.$parent.getAdditionalServiceByDesc(desc)
    },
  },
  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('AdditionalServicesInternational')
  },
}
</script>
